var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-sidebar" },
    [
      _c("booking-tour-operator", { attrs: { isCollapsed: _vm.isCollapsed } }),
      _vm._v(" "),
      _c(
        "booking-block",
        {
          staticClass: "booking-block--travel-details",
          attrs: {
            title: _vm.translations.title,
            subTitle: _vm.subTitle,
            editMode: false,
            valid: true,
            showEditBtn: false,
            showSaveBtn: false,
            isCollapsed: _vm.isCollapsed
          }
        },
        [
          _c("template", { slot: "view" }, [
            _c("div", { staticClass: "booking-travel" }, [
              _c(
                "div",
                {
                  staticClass:
                    "\n            booking-travel__item\n            booking-travel__item--flex\n            booking-travel__item--two-col\n          "
                },
                [
                  _c("div", { staticClass: "booking-travel__item__sub" }, [
                    _c("span", { staticClass: "icon" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "icon-cal",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 350.43 335.51"
                          }
                        },
                        [
                          _c("rect", {
                            attrs: {
                              x: "124.1",
                              y: "123.45",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "189.36",
                              y: "123.45",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "254.61",
                              y: "123.45",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "124.1",
                              y: "181.59",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "58.85",
                              y: "181.59",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "189.36",
                              y: "181.59",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "254.61",
                              y: "181.59",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "124.1",
                              y: "239.73",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "58.85",
                              y: "239.73",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M344.43,64H6a6,6,0,0,0-6,6V329.51a6,6,0,0,0,6,6H344.43a6,6,0,0,0,6-6V70A6,6,0,0,0,344.43,64ZM26.64,301.87V98a10,10,0,0,1,9.53-7H313.79a10,10,0,0,1,10,10V298.84a10,10,0,0,1-10,10H36.17A10,10,0,0,1,26.64,301.87Z",
                              transform: "translate(0)"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "284.73",
                              width: "28.4",
                              height: "50.91",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "37.3",
                              width: "28.4",
                              height: "50.91",
                              rx: "6",
                              ry: "6"
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.translations.from) + " "),
                      _c("span", {
                        domProps: { textContent: _vm._s(_vm.departureDate) }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "booking-travel__item__sub" }, [
                    _c("span", { staticClass: "icon" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "icon-cal",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 350.43 335.51"
                          }
                        },
                        [
                          _c("rect", {
                            attrs: {
                              x: "124.1",
                              y: "123.45",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "189.36",
                              y: "123.45",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "254.61",
                              y: "123.45",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "124.1",
                              y: "181.59",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "58.85",
                              y: "181.59",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "189.36",
                              y: "181.59",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "254.61",
                              y: "181.59",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "124.1",
                              y: "239.73",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "58.85",
                              y: "239.73",
                              width: "36.61",
                              height: "36.61",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M344.43,64H6a6,6,0,0,0-6,6V329.51a6,6,0,0,0,6,6H344.43a6,6,0,0,0,6-6V70A6,6,0,0,0,344.43,64ZM26.64,301.87V98a10,10,0,0,1,9.53-7H313.79a10,10,0,0,1,10,10V298.84a10,10,0,0,1-10,10H36.17A10,10,0,0,1,26.64,301.87Z",
                              transform: "translate(0)"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "284.73",
                              width: "28.4",
                              height: "50.91",
                              rx: "6",
                              ry: "6"
                            }
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "37.3",
                              width: "28.4",
                              height: "50.91",
                              rx: "6",
                              ry: "6"
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.translations.to) + " "),
                      _c("span", {
                        domProps: { textContent: _vm._s(_vm.homeAgainDate) }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "booking-travel__item booking-travel__item--flex"
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("img", {
                      attrs: {
                        src: require("./../../img/icons/icon-location-pin-map.svg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.translations.destination) +
                        "\n            "
                    ),
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.destination.name) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "booking-travel__item booking-travel__item--flex"
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "icon-person",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 511.18 490.04"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M187.83,490c-44.06-.32-79.51-1.42-114.53-8.06-16.73-3.17-33.16-7.4-48.23-15.71C8.75,457.27.19,444.48,0,424.83c-.21-21.56,11.12-35.61,25.83-48.29,20.79-17.91,45-30.12,69.93-41.1,4.57-2,9.12-4.19,13.9-5.53,8.62-2.41,13.8-8.24,17.51-15.87A42.14,42.14,0,0,0,129,280.57c-.73-2.09-2.42-3.93-3.91-5.67C96.59,241.43,81,203,81.59,158.77c.32-25.36,7.35-48.77,24.82-67.92,21.2-23.23,48.34-31.89,79-29.4,32.18,2.61,57.94,17.15,74.54,45.41,13.34,22.71,16.26,47.73,12.73,73.46-5,36.2-20.7,67.49-44.65,94.86a18.74,18.74,0,0,0-3.85,7.33c-3.6,13.69-3.61,27.16,4.83,39.29a18.61,18.61,0,0,0,8.39,6.44c29.36,10.71,57.72,23.31,83,42.07,10.08,7.49,19.13,16,26,26.7,14.23,22.06,7.59,53.21-14.48,67.19-15.63,9.9-33.2,14.53-51.12,17.66-14.41,2.52-29,4.54-43.56,5.7C217.94,489.08,198.61,489.53,187.83,490Z",
                            transform: "translate(0 0)"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M264.52,296c9.67-16.23,20.19-31.52,28.32-48,19.06-38.58,25.93-79.26,16.62-121.85-6-27.29-19.11-50.62-39.86-69.5-1.23-1.12-2.43-2.27-3.65-3.41a7.06,7.06,0,0,1-.51-.85c8-20.13,21.34-35.95,41.78-44.21,34.6-14,67.46-10.75,96.16,14.36,17.8,15.57,25.73,36.72,27.52,59.82,3.48,44.91-9.28,84.89-38.46,119.42-5.29,6.25-7.79,22.53-3.24,29.32a23,23,0,0,0,10.74,8.07c20.68,7.58,41,16,59.94,27.19,16.27,9.63,31.76,20.26,42.74,36.18,16.08,23.29,8.83,53.81-16.07,67.22-18.8,10.13-39.36,14.23-60.21,17.05-11.71,1.59-23.52,2.46-35.31,3.34-1.61.12-4.27-1.19-4.9-2.55-9.89-21.59-26.14-37.58-44.89-51.35-21.35-15.67-44.9-27.31-69.35-37.23C269.12,298,266.37,296.8,264.52,296Z",
                            transform: "translate(0 0)"
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.translations.travelers) +
                        "\n            "
                    ),
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.numberOfTravelers) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "booking-travel__item booking-travel__item--flex"
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("img", {
                      attrs: {
                        src: require("./../../img/icons/icon-hotel.svg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item-booking-travel__item__roomtype" },
                    [
                      _c("p", [_vm._v(_vm._s(_vm.translations.room_type))]),
                      _vm._v(" "),
                      _vm._l(_vm.roomNameText, function(line, key) {
                        return _c("span", {
                          key: key,
                          domProps: { textContent: _vm._s(line) }
                        })
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.hasRoomNameTranslation
                    ? _c(
                        "button",
                        {
                          staticClass: "translate-btn",
                          attrs: {
                            title: !_vm.showOriginalRoomTypeText
                              ? _vm.translations.translations_info_link
                              : _vm.translations.translations_info_link_original
                          },
                          on: {
                            click: function($event) {
                              _vm.showOriginalRoomTypeText = !_vm.showOriginalRoomTypeText
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 32 32"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "m22.69,7.51l-2.33-1.17-.67,1.35,5.51,2.76.59-5.62-1.5-.16-.23,2.21c-1.62-3.09-4.46-5.41-7.87-6.35l-.4,1.45c2.98.82,5.47,2.83,6.9,5.52Z"
                                }
                              }),
                              _c("path", {
                                attrs: {
                                  d:
                                    "m8.83,25.09l1.36.97.87-1.22-4.51-3.22-.69,5.89,1.49.17.21-1.78c1.74,3.02,4.66,5.24,8.09,6.09l.36-1.46c-3.06-.76-5.65-2.74-7.18-5.44Z"
                                }
                              }),
                              _c("path", {
                                attrs: {
                                  d:
                                    "m27.71,27.85l.28-1.48c-1.87-.36-3.42-.99-4.65-1.88.56-.59.98-1.19,1.29-1.75.71-1.25.98-2.42,1.09-3.15h2.13v-1.5h-4.89v-2.09h-1.5v2.09h-4.89v1.5h2.13c.11.73.38,1.9,1.09,3.15.31.55.73,1.15,1.29,1.75-1.23.9-2.79,1.53-4.65,1.88l.28,1.48c2.44-.47,4.22-1.34,5.5-2.34,1.28.99,3.06,1.87,5.5,2.34Zm-3.52-8.25c-.11.61-.36,1.51-.91,2.47-.3.52-.66,1-1.07,1.44-.41-.44-.77-.91-1.07-1.44-.55-.95-.8-1.86-.91-2.47h3.96Z"
                                }
                              }),
                              _c("path", {
                                attrs: {
                                  d:
                                    "m8.14,4.42l-3.93,11.12h1.82l1.11-3.13h4.15l1.15,3.13h1.93l-4.1-11.12h-2.15Zm2.69,6.42h-3.21l.2-.59c.6-1.78,1.09-3.23,1.36-4.13.23.74.64,1.88,1.26,3.61.12.34.25.71.39,1.1Z"
                                }
                              }),
                              _c("path", {
                                attrs: {
                                  d:
                                    "m12.73,18.46H2.56c-.33,0-.61-.27-.61-.61V2.11c0-.33.27-.61.61-.61h10.18V0H2.56C1.39,0,.44.95.44,2.11v15.74c0,1.16.95,2.11,2.11,2.11h10.18v-1.5Z"
                                }
                              }),
                              _c("path", {
                                attrs: {
                                  d:
                                    "m29.44,12.01h-10.18v1.5h10.18c.33,0,.61.27.61.61v15.74c0,.33-.27.61-.61.61h-10.18v1.5h10.18c1.16,0,2.11-.95,2.11-2.11v-15.74c0-1.16-.95-2.11-2.11-2.11Z"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "booking-travel__item booking-travel__item--flex"
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("img", {
                      attrs: { src: require("./../../img/icons/icon-food.svg") }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            " + _vm._s(_vm.translations.food) + " "
                    ),
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.offerData.boardType) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "booking-travel__item booking-travel__item--flex"
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("img", {
                      attrs: {
                        src: require("./../../img/icons/icon-transfer.svg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.translations.transfer) +
                        "\n            "
                    ),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.offerData.transferInlcuded
                            ? _vm.translations.transfer_included
                            : _vm.translations.transfer_not_included
                        )
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "booking-travel__item booking-travel__item--flex"
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("img", {
                      attrs: {
                        src: require("./../../img/icons/icon-baggage.svg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.translations.luggage) +
                        "\n            "
                    ),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.translations.logage_included)
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "booking-travel__item booking-travel__item--flex"
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("img", {
                      attrs: {
                        src: require("./../../img/icons/icon-travel-world.svg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.translations.tour_operator) +
                        "\n            "
                    ),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.offerData.tourOperator)
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "booking-travel__item booking-travel__item--flex"
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "icon-plane-from",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 459.19 244.57"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M447.31,47.35l-317,191s-12.17,6.23-38,6.22c-10,0-24.92-2-42.58-11.72C32.52,223.44,1.89,201.93.31,200.35c-3-3,16.75-23,21.5-22.08,6,1.16,16.38,4.38,28.5,5,15,.76,30.42-1.5,39.05-4.53l94.25-55L34.31,25.35s14-17,16-19,17-15.67,66.5,4.67c52.57,21.59,151.5,63.33,151.5,63.33l121-69c7-4,46.54-8.63,63,6C470.31,27.35,447.31,47.35,447.31,47.35Z"
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.translations.flight_class) +
                        "\n            "
                    ),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.translations.flight_class_type)
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "booking-travel__item booking-travel__item--flex"
                },
                [
                  _vm.offerData.handicap
                    ? _c("span", { staticClass: "icon" }, [
                        _c("img", {
                          attrs: {
                            src: require("./../../img/icons/icon-handicap.svg")
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.offerData.handicap
                    ? _c("span", { staticClass: "icon" }, [
                        _c("img", {
                          attrs: {
                            src: require("./../../img/icons/icon-handicap.svg")
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.translations.handicap_title) +
                        " "
                    ),
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.handicapStr) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "booking-travel__item" },
                [
                  _c("travel-block", {
                    attrs: {
                      title: _vm.translations.travel_out,
                      flightData: _vm.offerData.outboundFlight
                    },
                    on: { showTravelInfo: _vm.onShowFlightTimesOutbound }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "booking-travel__item__text-center",
                    domProps: {
                      textContent: _vm._s(_vm.translations.flight_notice)
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "booking-travel__item" },
                [
                  _c("travel-block", {
                    attrs: {
                      title: _vm.translations.travel_home,
                      "flight-data": _vm.offerData.inboundFlight
                    },
                    on: { showTravelInfo: _vm.onShowFlightTimesInbound }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "booking-travel__item__text-center",
                    domProps: {
                      textContent: _vm._s(_vm.translations.flight_notice)
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "booking-travel__item" },
                [
                  _vm.offerData.totalPrice
                    ? _c("total-price", {
                        attrs: {
                          totalPrice: _vm.offerData.totalPrice.value,
                          currency: _vm.offerData.totalPrice.currency,
                          "show-from": false
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48de4de5", { render: render, staticRenderFns: staticRenderFns })
  }
}